// extracted by mini-css-extract-plugin
export default {"actions":"glossaryListItem_actions__s+9HI","up-down":"glossaryListItem_up-down__ANd+7"};